// extracted by mini-css-extract-plugin
module.exports = {"highlight":"HighlightMatches_highlight__2jRVS"};